import Vue from 'vue'
import VModal from 'vue-js-modal'
// import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VModal, { dialog: true })

/** Login */
Vue.component('log-in-form-cmponent', require('./components/Login/LogInFormCmponent.vue').default)

/** Change password */
Vue.component('request-change-password-component', require('./components/ChangePassword/RequestChangePasswordComponent.vue').default)
Vue.component('cange-password-form-component', require('./components/ChangePassword/CangePasswordFormComponent.vue').default)

/** Registration */
Vue.component('registration-form-cmponent', require('./components/Registration/RegistrationFormCmponent.vue').default)
Vue.component('confirm-registration-component', require('./components/Registration/ConfirmRegistrationComponent.vue').default)

/** Personal Area */
Vue.component('root-personal-area', require('./components/PersonalArea/RootPersonalArea.vue').default)
Vue.component('send-email-component', require('./components/PersonalArea/SendEmailComponent.vue').default)

/** Gallery */
Vue.component('gallery-component', require('./components/Gallery/GalleryComponent.vue').default)
Vue.component('gallery-component-secondary', require('./components/Gallery/GalleryComponentSecondary.vue').default)

/** Welcome Kit */
Vue.component('download-doc-component', require('./components/Common/DownloadDocComponent.vue').default)

/** FAQ Kit */
Vue.component('faq-component', require('./components/FAQ/FaqComponent.vue').default)

/** Inizialize VUE */
new Vue({
	el: '#app'
})

